/* eslint-disable */
import { httpPostObservable } from './utils';

const api = {
  fetchProviderList: (url, params) => httpPostObservable(url, params),
  fetchRegister: (url, params) => httpPostObservable(url, params)
};

export default api;
